import useSWR from "swr";
import useUser from "../../context/userHook";
import { getConnectedBoards } from "../../../utils/requests/boardSettingsRequest";
import { MondayApiQueryInstance } from "../../../services/monday/monday-service-ts";

const useBoardSettings = (token: string, boardId: number) => {
  const { userId } = useUser();

  const fetcher = async () => {
    try {
      const response = await getConnectedBoards(token, boardId);

      if (response.length === 0) {
        return [];
      }

      const boardIds = response.map((board: any) => parseInt(board.boardid));

      const boardData = await MondayApiQueryInstance.getBoardDetails(boardIds);

      const boardOptions = boardData.reduce((acc: any, board: any) => {
        acc.push({
          label: board.name,
          value: board.id,
        });
        return acc;
      }, []);

      return boardOptions;
    } catch (error) {
      throw error;
    }
  };
  const { error, data, isLoading, mutate, isValidating } = useSWR(token && userId && boardId ? `connected-boards-options:${userId}:${boardId}` : null, () =>
    fetcher()
  );

  return {
    isLoading,
    error,
    connectedBoardsData: data || null,
    mutate,
    isValidating,
  };
};

export default useBoardSettings;
